<script>
import CardNewsItem from './CardNewsItem'
import moment from 'moment'

export default {
  name: 'CardNewsItemResumo',
  props: {
    dataLimiteGratuidade: {
      type: Object
    },
    dataAgendamento: {
      type: [Object, null],
      required: false,
      default: null
    },
    grv: {
      type: Object
    },
    datasExtraModel: {
      type: Object
    }
  },
  components: {CardNewsItem},
  methods: {
    formataData (data, format = 'L LT') {
      const formataData = date => date ? moment(date).format(format) : null
      if (typeof data === 'string') return formataData(data)
      if (typeof data === 'object' && data.hasOwnProperty('date')) {
        return formataData(data.date)
      }
      return null
    },
    formataDataGratuidade ({date}) {
      // remoção rodando
      if (this.grv.tipoRemocao === 1) {
        return this.formataData(date)
      }
      return this.formataData(date, 'L')
    }
  }
}
</script>

<template>
  <card-news-item title="Resumo">
    <div class="row m-t-xs" v-if="grv.patio.naoEmitirBoleto">
      <div class="col-xs-12 text-danger text-xs">(Sem emissão de boleto)</div>
    </div>
    <div class="row m-t" v-if="dataAgendamento">
      <div class="col-xs-12">Data do agendamento:</div>
      <div class="col-xs-12 font-bold item-d" style="color: #d35400">{{formataData(dataAgendamento)}} </div>
    </div>
    <div class="row m-t" v-else-if="dataLimiteGratuidade">
      <div class="col-xs-12">Data limite de gratuidade:</div>
      <div class="col-xs-12 font-bold item-d" style="color: #d35400">{{formataDataGratuidade(dataLimiteGratuidade)}} </div>
    </div>
    <div class="row m-t">
      <div class="col-xs-12">Apreensão:</div>
      <div class="col-xs-12 font-bold item-d">{{datasExtraModel.dataApreensao}} {{datasExtraModel.horaApreensao}}</div>
    </div>
    <div class="row m-t">
      <div class="col-xs-12">Remoção:</div>
      <div class="col-xs-12 font-bold item-d">{{datasExtraModel.dataRemocao}} {{datasExtraModel.horaRemocao}}</div>
    </div>
    <div class="row m-t">
      <div class="col-xs-12">Entrada no pátio:</div>
      <div class="col-xs-12 font-bold item-d">{{moment(grv.ggv.dataCadastro.date).format('L')}}
        {{moment(grv.ggv.dataCadastro.date).format('LTS')}}
      </div>
    </div>
    <div class="row m-t">
      <div class="col-xs-12">Pátio:</div>
      <div class="col-xs-12 font-bold item-d">{{grv.patio.nome}} (#{{grv.patio.id}})</div>
    </div>
    <div class="row m-t">
      <div class="col-xs-12">Vaga:</div>
      <div class="col-xs-12 font-bold item-d">{{grv.vaga || '-'}}</div>
    </div>
    <div class="row m-t">
      <div class="col-xs-12">Número da chave:</div>
      <div class="col-xs-12 font-bold item-d">{{grv.numeroChave || '-'}}</div>
    </div>
    <div class="row m-t" v-if="grv.liberarPorDecisaoJudicial">
      <div class="col-xs-12 font-bold item-d" style="color: red">LIBERADO POR DECISÃO JUDICIAL</div>
    </div>
  </card-news-item>
</template>

<style scoped>
.item-d {
  color: #303f9f;
}
</style>



// WEBPACK FOOTER //
// CardNewsItemResumo.vue?c9709356